"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var BestOfBadge3dIcon = function BestOfBadge3dIcon(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "52",
    height: "66",
    viewBox: "0 0 52 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    className: className
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M52 0.284668H0V62.7716C0 63.9772 1.21555 64.8032 2.33644 64.3592L24.9117 55.4174C25.2816 55.2708 25.693 55.2681 26.0649 55.4097L49.6848 64.4031C50.8024 64.8287 52 64.0032 52 62.8073V0.284668Z",
    fill: "url(#paint0_linear_1156_53687)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.2825 55.3204L0 44.6978V62.9412C0 64.0655 1.13367 64.8359 2.17904 64.4218L24.9117 55.4176C25.0319 55.37 25.1564 55.3376 25.2825 55.3204Z",
    fill: "#00682C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.5561 55.9773L0 44.6914V44.7024L22.6241 56.3233L24.9117 55.4172C25.2816 55.2707 25.693 55.268 26.0649 55.4096L27.5561 55.9773Z",
    fill: "#00482F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.9411 13.1433C20.8534 13.1109 20.76 13.0918 20.6647 13.0918H13.0161C12.7054 13.0918 12.4539 13.3434 12.4539 13.6541V21.6286L20.9411 13.1433Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.6177 38.5401C12.7187 38.6411 12.8597 38.704 13.016 38.704H20.4283C20.739 38.704 20.9905 38.4524 20.9905 38.1418V30.1672L12.6177 38.5401Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.5293 21.6284V38.6315C29.5465 38.6391 29.5636 38.6467 29.5808 38.6524L38.068 30.1652L29.5312 21.6284H29.5293Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.9906 30.167V13.164C20.9735 13.1564 20.9563 13.1487 20.9392 13.1411L12.4539 21.6283V38.1416C12.4539 38.2959 12.5168 38.437 12.6178 38.5399L20.9906 30.167Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.0661 30.1673V21.6305V13.6541C38.0661 13.3434 37.8145 13.0918 37.5038 13.0918H30.0916C29.7809 13.0918 29.5293 13.3434 29.5293 13.6521V21.6286L38.0661 30.1654V30.1673Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.0661 30.1672L29.5789 38.6545C29.6665 38.6869 29.7599 38.7059 29.8552 38.7059H37.5038C37.8145 38.7059 38.0661 38.4543 38.0661 38.1437V30.1691V30.1672Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.2213 13.3223C21.1546 13.2555 21.0746 13.2022 20.9907 13.1641V30.1671L29.2969 38.4733C29.3636 38.54 29.4436 38.5933 29.5275 38.6315V21.6284L21.2213 13.3223Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint0_linear_1156_53687",
    x1: "5.79065",
    y1: "5.351",
    x2: "51.556",
    y2: "28.4459",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#00682C"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#2A9859"
  }))));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var PropTypes = require('prop-types');
  BestOfBadge3dIcon.propTypes = {
    className: PropTypes.string
  };
}
var _default = BestOfBadge3dIcon;
exports.default = _default;